import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { withStyles } from '@mui/styles';


const styles = {
  root: {
    // background: 'linear-gradient(135deg, #65c5ac 30%, #255845 90%)',
    // background: 'linear-gradient(135deg, #209cb3 30%, #4ea685 90%)',
    background: 'linear-gradient(135deg, #50A684 30%, #115E67 90%)',
    borderRadius: 3,
    border: 0,
    color: 'white',
    height: 48,
    padding: '0 30px',
    boxShadow: '0 3px 5px 2px rgba(135, 135, 135, .3)',
  },
  label: {
    textTransform: 'capitalize',
  },
};

function ClassesNesting(props) {
  const { classes, children } = props;

  return (
    <Button
      classes={{
        root: classes.root, // class name, e.g. `classes-nesting-root-x`
        label: classes.label, // class name, e.g. `classes-nesting-label-x`
      }}
      {...props}
    >
    { children }
    </Button>
  );
}

ClassesNesting.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ClassesNesting);


// WEBPACK FOOTER //
// ./src/components/button/index.js